import _extends from "@babel/runtime/helpers/extends";
import cx from 'classnames';
import React from 'react';
import { getUnhandledProps, useValueAndKey } from '../../lib';
import TableCell from './TableCell';
/**
 * A table can have a header cell.
 */

function TableHeaderCell(props) {
  var as = props.as,
    className = props.className,
    sorted = props.sorted;
  var classes = cx(useValueAndKey(sorted, 'sorted'), className);
  var rest = getUnhandledProps(TableHeaderCell, props);
  return React.createElement(TableCell, _extends({}, rest, {
    as: as,
    className: classes
  }));
}
TableHeaderCell.handledProps = ["as", "className", "sorted"];
TableHeaderCell.defaultProps = {
  as: 'th'
};
export default TableHeaderCell;